import axios, { AxiosInstance, AxiosResponse } from 'axios';

class HttpService {
  static timeout = 15000;
  baseUrl = process.env.REACT_APP_EXP_API_BASE_URL;
  API_KEY = process.env.REACT_APP_EXP_API_MASHERY_KEY;
  apiClient: AxiosInstance;
  instance: AxiosInstance;
  constructor() {
    this.apiClient = axios.create();
    this.instance = axios.create({
      baseURL: this.baseUrl,
      timeout: 15000,
      headers: { api_key: `${this.API_KEY}`, 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.put = this.put.bind(this);
    this.delete = this.delete.bind(this);

    this.getJahiaContent = this.getJahiaContent.bind(this);
  }
  async getJahiaContent<T>(url: string): Promise<T> {
    const resp: AxiosResponse<T> = await this.instance.get<string, AxiosResponse<T>>(url);
    const { data } = resp;
    return data;
  }
  async get<T>(url: string): Promise<T> {
    const resp: AxiosResponse<T> = await this.apiClient.get<string, AxiosResponse<T>>(url);
    const { data } = resp;
    return data;
  }

  async delete(url: string) {
    try {
      return await this.apiClient.delete(url);
    } catch (error) {
      console.log(error);
    }
  }

  async post(url: string, params?: object) {
    try {
      return await this.apiClient.post(url, params);
    } catch (error) {
      console.log(error);
    }
  }

  async put(url: string, params: object) {
    try {
      return await this.apiClient.put(url, params);
    } catch (error) {
      console.log(error);
    }
  }

  async patch(url: string, params: object) {
    try {
      return await this.apiClient.patch(url, params);
    } catch (error) {
      console.log(error);
    }
  }
}

export default new HttpService();
